import React from "react";

function ReferralStat(props) {
  return (
    <>
      <div className="referral-stat">
        <h6>{props.header}</h6>
        <p>{props.statistic}</p>
      </div>
    </>
  );
}

export default ReferralStat;
